import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Combustibles } from '@/app/models/Combustibles';
import { AlmacenesService } from '@/app/services/almacenes.service';
import { CombustiblesService } from '@/app/services/combustibles.service';
import { Estaciones } from '@/app/models/Estaciones';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { EstacionesService } from '@/app/services/estaciones.service';
import { EstatusService } from '@/app/services/estatus.service';
import { TokenReaderService } from '@/app/services/security/token-reader.service';

@Component({
    selector: 'app-crear-almacen',
    templateUrl: './crear-almacen.component.html',
    styleUrls: ['./crear-almacen.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CrearAlmacenComponent {
  private spinner = inject(NgxSpinnerService);

  //model 
  AlmacenRQ = {
    idEstacion: '',
    descripcion: '',
    idCombustible: '',
    idEstatus: '',
    idSite: '',
    codigo: '',
    creadoPor: '',
  }

  //catalogos
  estaciones: Estaciones[] =[];
  combustibles: Combustibles[] = [];
  estatusCatalog: any[] = [];

    //Bandera global para cerrar el modal
    hasFinished: boolean = false;
  
    constructor
    (
      private almacenesService: AlmacenesService,
      private estacionesService: EstacionesService,
      private combustiblesService: CombustiblesService,
      private toastr: ToastrService, 
      private router: Router,
      public dialogRef: MatDialogRef<CrearAlmacenComponent>,
      private estatusService: EstatusService,
      private userTokenReaderService: TokenReaderService,
    )
    {
      this.getEstaciones();
      this.getEstatus();
      this.obtenerCombustibles();
    }

    getEstaciones(){
      this.estacionesService.obtenerEstaciones().subscribe({
        next: (data: any)=>{
          if(data != null && data.Estaciones != null && Array.isArray(data.Estaciones) && data.Estaciones.length > 0){

            this.estaciones = data.Estaciones.filter( (i: any) => i['IATA'] != '').map( (i: any) => {return {'label': i.IATA, 'value': i.IATA} } );    
            this.AlmacenRQ.idEstacion = data.Estaciones[0].IATA;

          }else{
            this.estaciones = [];
            this.AlmacenRQ.idEstacion = '';
          }
        },
        error: (err) =>{
          this.spinner.hide();
          
          if(err.status == 401){
            this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
            this.router.navigate(['/login']);
          }else{
            if(err.error){
              let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
            }
          }
          console.log(err);
        }
      });
    }

    getEstatus(){
      this.estatusService.getEstatus().subscribe({
        next: (data: any)=>{
          if(data != null && data.Estatus != null && Array.isArray(data.Estatus) && data.Estatus.length > 0){
            this.estatusCatalog = data.Estatus
              .filter( (x: any) => x['AplicaAlmacen'] === 'True' || x['AplicaAlmacen'] == 1)
              .map( (i: any) => {return {'label': i.estatus, 'value': i.estatus} } );    
          }else{
            this.estatusCatalog = [];
            this.AlmacenRQ.idEstatus = '';
          }
        },
        error: (err) =>{
          this.spinner.hide();
          if(err.status == 401){
            this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
            this.router.navigate(['/login']);
          }else{
            if(err.error){
              let { ClassInfo } = err.error;
              this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
            }
          }
          console.log(err);
        }
      });
    }

    obtenerCombustibles(){
      this.combustiblesService.obtenerCombustibles().subscribe({
        next: (data: any)=>{

          if(data != null && data.Combustible != null && data.Combustible.length > 0){

            this.combustibles = data.Combustible.map( (i: any) => {return {'label': i.tipo, 'value': i.tipo} } );  
          }else{
            this.combustibles = [];
            this.AlmacenRQ.idCombustible = '';
          }
  
        },
        error: (err) =>{
          this.spinner.hide();
          
          if(err.status == 401){
            this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
            this.router.navigate(['/login']);
          }else{
            if(err.error){
              let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
            }
          }
          console.log(err);
        }
      });
    }

      //Submit y crear almacen
  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas crear un nuevo almacén?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.crearAlmacen();
        }
      });
    }
  }

  crearAlmacen(){
    this.spinner.show();
    this.AlmacenRQ.creadoPor = this.userTokenReaderService.getUserData().idUsuario;
    
    this.almacenesService.insertAlmacenes(this.AlmacenRQ).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Almacén registrado correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();
        });

      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ExceptionMessage } = err.error;
            this.toastr.error(ExceptionMessage ? ExceptionMessage : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
          }
        }
        console.log(err);
      }
    });
  }


  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha registrado el almacén. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      this.dialogRef.close({updateList: true});
    }

  }
  
}
